var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotification1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.58691V13.0269",
    stroke: "white",
    strokeWidth: 1.45455,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0275 2.66699C11.1208 2.66699 7.14751 6.64032 7.14751 11.547V14.347C7.14751 15.2537 6.77417 16.6137 6.30751 17.387L4.61417 20.2137C3.57417 21.9603 4.29417 23.907 6.21417 24.547C12.5875 26.667 19.4808 26.667 25.8542 24.547C27.6542 23.947 28.4275 21.8403 27.4542 20.2137L25.7608 17.387C25.2942 16.6137 24.9208 15.2403 24.9208 14.347V11.547C24.9075 6.66699 20.9075 2.66699 16.0275 2.66699Z",
    stroke: "white",
    strokeWidth: 1.45455,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4396 25.0938C20.4396 27.5338 18.4396 29.5338 15.9996 29.5338C14.7862 29.5338 13.6662 29.0271 12.8662 28.2271C12.0662 27.4271 11.5596 26.3071 11.5596 25.0938",
    stroke: "white",
    strokeWidth: 1.45455,
    strokeMiterlimit: 10
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification1);
export default __webpack_public_path__ + "static/media/notification1.ed8de30839f153c4982a34b61ad1b5ef.svg";
export { ForwardRef as ReactComponent };